import { useId } from 'react';

import Icon from 'ms-ui-primitives/Icon';

import type { Props } from '../types';

const PencilUnderline = ({
  color,
  size,
  title,
  titleId,
  aphroditeStyles = [],
}: Props) => {
  const maskId1 = useId();
  const maskId2 = useId();
  return (
    <Icon
      color={color}
      size={size}
      aphroditeStyles={aphroditeStyles}
      title={title}
      titleId={titleId}
      viewBoxWidth={25}
      viewBoxHeight={24}
    >
      <mask
        id={maskId1}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="21"
        height="22"
      >
        <mask
          id={maskId2}
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="25"
          height="24"
        >
          <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask={`url(#${maskId2})`}>
          <path
            d="M4.5 24C3.95 24 3.47917 23.8042 3.0875 23.4125C2.69583 23.0208 2.5 22.55 2.5 22C2.5 21.45 2.69583 20.9792 3.0875 20.5875C3.47917 20.1958 3.95 20 4.5 20H20.5C21.05 20 21.5208 20.1958 21.9125 20.5875C22.3042 20.9792 22.5 21.45 22.5 22C22.5 22.55 22.3042 23.0208 21.9125 23.4125C21.5208 23.8042 21.05 24 20.5 24H4.5ZM6.5 16H7.9L15.7 8.225L14.275 6.8L6.5 14.6V16ZM4.5 17V14.175C4.5 14.0417 4.525 13.9125 4.575 13.7875C4.625 13.6625 4.7 13.55 4.8 13.45L15.7 2.575C15.8833 2.39167 16.0958 2.25 16.3375 2.15C16.5792 2.05 16.8333 2 17.1 2C17.3667 2 17.625 2.05 17.875 2.15C18.125 2.25 18.35 2.4 18.55 2.6L19.925 4C20.125 4.18333 20.2708 4.4 20.3625 4.65C20.4542 4.9 20.5 5.15833 20.5 5.425C20.5 5.675 20.4542 5.92083 20.3625 6.1625C20.2708 6.40417 20.125 6.625 19.925 6.825L9.05 17.7C8.95 17.8 8.8375 17.875 8.7125 17.925C8.5875 17.975 8.45833 18 8.325 18H5.5C5.21667 18 4.97917 17.9042 4.7875 17.7125C4.59583 17.5208 4.5 17.2833 4.5 17Z"
            fill={color}
          />
        </g>
      </mask>
      <g mask={`url(#${maskId1})`}>
        <rect x="0.5" width="24" height="24" fill="white" />
      </g>
    </Icon>
  );
};

PencilUnderline.displayName = 'PencilUnderline';

export default PencilUnderline;
